var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "employment-details-step" },
    [
      _c("p", { staticClass: "fm-section-label" }, [_vm._v("Employment")]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("EmploymentStatusSelect", {
              attrs: {
                "error-container": _vm.errorContainerName,
                name: "employmentStatus",
                floating: true,
              },
              model: {
                value: _vm.form.employmentStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "employmentStatus", $$v)
                },
                expression: "form.employmentStatus",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Employer Name",
                  name: "employer",
                  floating: true,
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.employer,
                      expression: "form.employer",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: " " },
                  domProps: { value: _vm.form.employer },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "employer", $event.target.value)
                    },
                  },
                }),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fm-section-label mt-1" }, [_vm._v("Income")]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Employment Income (after tax)",
                  name: "income",
                  floating: true,
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v("$"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.income,
                        expression: "form.income",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", min: "1", placeholder: " " },
                    domProps: { value: _vm.form.income },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "income", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("FrequencySelect", {
              attrs: {
                "error-container": _vm.errorContainerName,
                name: "incomeFrequency",
                floating: true,
              },
              model: {
                value: _vm.form.incomeFrequency,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "incomeFrequency", $$v)
                },
                expression: "form.incomeFrequency",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Other Income (optional)",
                  name: "otherIncome",
                  floating: true,
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v("$"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.otherIncome,
                        expression: "form.otherIncome",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", min: "0", placeholder: " " },
                    domProps: { value: _vm.form.otherIncome },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "otherIncome", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("FrequencySelect", {
              attrs: {
                "error-container": _vm.errorContainerName,
                name: "otherIncomeFrequency",
                floating: true,
              },
              model: {
                value: _vm.form.otherIncomeFrequency,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "otherIncomeFrequency", $$v)
                },
                expression: "form.otherIncomeFrequency",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fm-section-label mt-1" }, [_vm._v("Expenses")]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Housing Expense",
                  name: "houseExpense",
                  floating: true,
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v("$"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.houseExpense,
                        expression: "form.houseExpense",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", min: "1", placeholder: " " },
                    domProps: { value: _vm.form.houseExpense },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "houseExpense", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("FrequencySelect", {
              attrs: {
                "error-container": _vm.errorContainerName,
                name: "houseExpenseFrequency",
                floating: true,
              },
              model: {
                value: _vm.form.houseExpenseFrequency,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "houseExpenseFrequency", $$v)
                },
                expression: "form.houseExpenseFrequency",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Living Expenses",
                  name: "livingExpense",
                  floating: true,
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v("$"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.livingExpense,
                        expression: "form.livingExpense",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", min: "1", placeholder: " " },
                    domProps: { value: _vm.form.livingExpense },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "livingExpense", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("FrequencySelect", {
              attrs: {
                "error-container": _vm.errorContainerName,
                name: "livingExpenseFrequency",
                floating: true,
              },
              model: {
                value: _vm.form.livingExpenseFrequency,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "livingExpenseFrequency", $$v)
                },
                expression: "form.livingExpenseFrequency",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._t("controls", null, null, { prev: _vm.onPrev, next: _vm.onNext }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }